import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csuserfunc(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  
return(
    <div>
      <Sides/>
  
      <Helmet>
 
 <title>Learn Free JavaScript User Defined Function Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript userDefine function tutorial for beginners.userDefine function in Javascript is a collection of similar type of data and stored in manually consecutively under one name" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Javascript userDefine function,Javascript user Defined function for loop,javascript define function in class
,user defined function in javascript,javascript define function with callback,javascript define function multiple times" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-user-define-function" />
 </Helmet>


 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">User-defined function in Javascript</h1>
    <div className="first">
        <a href="/javascript-function"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-dom-method"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 
    <p className="mt-3 para">The Program can define its function, and a function consist of the following.
    </p>
    <h2 className="mt-4 mh2">There are five types of users define a function in Javascript:
</h2>
<h3 className="mt-4 mh3">1, Function prototype(declaration)<br/>
2, Function definition<br/>
3, Calling function (accessing)<br/>
4, Function argument(parameter)<br/>
5, Return value by the function<br/>
</h3>


<h2 className="headings">Q-Write a Program user defines a Function in Javascript Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-10">hello</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">hello function</span> 
        <span className="qwerty-3">"</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}{"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">This is a function programme </span> 
        <span className="qwerty-3">"</span> 
   
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;hello</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        <span className="qwerty-5">{` // calling function`}</span>
        {"\n"}
        <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">hello is a function</span> 
        <span className="qwerty-3">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"} {"\n"}
     </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;This is a function program </span>          
          {"\n"}
          <span className="qwerty-5">&nbsp;hello function</span>          
          {"\n"}
          <span className="qwerty-7">&nbsp;hello is a function </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q- What will be the output of the following function program when a person goes from the USA to stay in the UK and create a plane to travel to India in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-10">USA</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">USA Journey</span> 
        <span className="qwerty-3">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-3">Uk</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;USA</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
      {"\n"}

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">UK Journey</span> 
        <span className="qwerty-3">"</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Travel Start </span> 
        <span className="qwerty-3">"</span> 
     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;Uk</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
        <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">India Journey</span> 
        <span className="qwerty-3">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}  {"\n"}
    
        </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;travel start </span>          
          {"\n"}
          <span className="qwerty-5">&nbsp;USA journey</span>          
          {"\n"}
          <span className="qwerty-2">&nbsp;UK journey </span>          
          {"\n"}
          <span className="qwerty-7">&nbsp;India journey </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>

  <div className="back">
        <a href="/javascript-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-dom-method">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csuserfunc;